import React from "react";

const Paynow = () => {
  return (
    <div className="text-center m-auto w-100">
      <a href="https://razorpay.me/@explorerscompany">
        <button type="button" className="btn btn-primary ">
          PayNow
        </button>
      </a>
    </div>
  );
};

export default Paynow;
